import { NgxSonnerToaster } from 'ngx-sonner';
import { register } from 'swiper/element/bundle';

import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

import { CoreModule, LocalizationModule, provideKeycloakAngular } from '@mitsubishi/core';
import {
  ApiUrlInjectionToken,
  AppEnvironment,
  AuthUrlInjectionToken,
  EnvironmentInjectionToken,
  IsDevEnvironmentToken,
  PACKAGE_JSON_VERSION,
} from '@mitsubishi/shared/data-access';
import { RequestTracingSpinnerComponent } from '@mitsubishi/shared/request-tracing';
import { provideUiConfigs } from '@mitsubishi/shared/ui';
import { ApmFormlyModule } from '@mitsubishi/ui/formly';
import { provideIcons } from '@mitsubishi/ui/icons';
import { SpinnerComponent } from '@mitsubishi/ui/spinner';

import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import * as Sentry from '@sentry/angular';
import { TraceService } from '@sentry/angular';

import packageJson from '../../../../package.json';
import { environment } from '../environments/environment';
import { AppStartupLoaderComponent } from './app-startup-loader/app-startup-loader.component';
import { AppComponent } from './app.component';
import { APP_ROUTES } from './app.routes';

@NgModule({
  declarations: [AppComponent, AppStartupLoaderComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(APP_ROUTES, { useHash: true }),
    CoreModule,
    LocalizationModule,
    ApmFormlyModule,
    NgxsReduxDevtoolsPluginModule.forRoot({ maxAge: 25, disabled: environment.production }),
    MatSidenavModule,
    SpinnerComponent,
    RequestTracingSpinnerComponent,
    MatProgressBar,
    CdkPortalOutlet,
    NgxSonnerToaster,
  ],
  providers: [
    provideKeycloakAngular(environment as AppEnvironment),
    { provide: PACKAGE_JSON_VERSION, useValue: packageJson.version },
    { provide: EnvironmentInjectionToken, useValue: environment },
    { provide: IsDevEnvironmentToken, useValue: environment.env === 'dev' },
    { provide: ApiUrlInjectionToken, useValue: environment.apiServerUrl },
    { provide: AuthUrlInjectionToken, useValue: environment.keycloakConfig.url },
    provideUiConfigs(),
    ...provideIcons(),
    ...(environment.sentry.enabled
      ? [
          {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
          },
          {
            provide: Sentry.TraceService,
            deps: [Router],
          },
          provideAppInitializer(() => {
            inject(TraceService);
          }),
        ]
      : []),
  ],
  bootstrap: [AppComponent, AppStartupLoaderComponent],
})
export class AppModule {
  constructor() {
    register();
  }
}
